import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import './style.css'  // 确保样式被导入
import i18n from './i18n'
import { setupGoogleAnalytics } from './plugins/analytics'

// 添加全局类型检查函数
window.safeTypeCheck = function(obj, method) {
  if (typeof obj === 'string' && typeof obj[method] === 'function') {
    return true;
  }
  return false;
}

// 修复字符串方法的安全调用
String.prototype.safeStartsWith = function(searchString, position) {
  try {
    return this.startsWith(searchString, position);
  } catch (e) {
    console.error('startsWith error:', e);
    return false;
  }
}

// 使用MutationObserver替代废弃的DOMNodeInserted事件
if (typeof window !== 'undefined') {
  // 存储所有DOMNodeInserted事件监听器
  const insertedListeners = new WeakMap();
  
  // 保存原始的事件监听器方法
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  const originalRemoveEventListener = EventTarget.prototype.removeEventListener;
  
  // 创建全局MutationObserver实例
  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          // 为每个新添加的节点触发事件
          const target = mutation.target;
          const listeners = insertedListeners.get(target);
          
          if (listeners) {
            const event = new CustomEvent('customDOMNodeInserted', {
              bubbles: true,
              cancelable: true,
              detail: { insertedNode: node }
            });
            
            listeners.forEach(listener => {
              try {
                listener.call(target, event);
              } catch (error) {
                console.error('Error in DOMNodeInserted listener:', error);
              }
            });
          }
        }
      }
    }
  });
  
  // 启动MutationObserver监听整个文档
  mutationObserver.observe(document, { 
    childList: true, 
    subtree: true 
  });
  
  // 重写addEventListener方法
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    if (type === 'DOMNodeInserted') {
      // 记录DOMNodeInserted监听器
      if (!insertedListeners.has(this)) {
        insertedListeners.set(this, new Set());
      }
      insertedListeners.get(this).add(listener);
      return;
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
  
  // 重写removeEventListener方法
  EventTarget.prototype.removeEventListener = function(type, listener, options) {
    if (type === 'DOMNodeInserted') {
      const listeners = insertedListeners.get(this);
      if (listeners) {
        listeners.delete(listener);
        if (listeners.size === 0) {
          insertedListeners.delete(this);
        }
      }
      return;
    }
    return originalRemoveEventListener.call(this, type, listener, options);
  };
}

// 初始化 Google Analytics
setupGoogleAnalytics()

// 创建Vue应用实例
const app = createApp(App)

// 创建head实例
const head = createHead()

// 使用路由和head
app.use(router)
app.use(head)
app.use(i18n)

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error(`Error: ${err.toString()}\nInfo: ${info}`);
}

// 挂载应用
app.mount('#app')
